import { render, staticRenderFns } from "./ShrinkedValue.vue?vue&type=template&id=2e5a75aa&scoped=true&"
import script from "./ShrinkedValue.vue?vue&type=script&lang=js&"
export * from "./ShrinkedValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5a75aa",
  null
  
)

export default component.exports